import { logWrapper } from '../../utils';

export default {
  personalizationController: [
    'runtimeConstant',
    '$scope',
    '$filter',
    '$state',
    '$uibModal',
    'authService',
    'systemConfigService',
    'webApiSettings',
    function (
      runtimeConstant,
      $scope,
      $filter,
      $state,
      uibModal,
      authService,
      systemConfigService,
      webApiSettings
    ) {
      'use strict';

      function isSysadmin() {
        return authService.isSysAdmin();
      }

      function tabTitle() {
        return $scope.selectedTab === 'geral'
          ? $filter('translate')('GENERAL SETTINGS')
          : $filter('translate')('CODE SETTINGS');
      }

      function getLogoImg() {
        if (!webApiSettings.showCompaniesLogo)
          return '/assets/images/logo/logo_branca.png';
        if ($scope.company && $scope.company.logo) {
          return `${webApiSettings.apiServiceBaseUri}companies/${$scope.company.Id}/logo`;
        }
        if ($scope.company.logo === '') {
          $scope.company.logo = document.getElementById('file_upload');
          $scope.company.logo = '/assets/images/logo/logo_branca.png';
        }
      }

      function addLogo(e) {
        if (e.target.files[0] !== undefined) {
          $scope.company.logo = e.target.files[0];
          $scope.image = document.getElementById('file_upload');
					$scope.messageTitle = $filter('translate')('THE.MAXIMUM.SIZE');
					$scope.messageDescription = $filter('translate')('THE.MAXIMUM.SIZE.ALLOWED.IS');
					$scope.messageCancel = $filter('translate')('OK');

          var reader = new FileReader();

          reader.onload = () => {
            var dataURL = reader.result;
            $scope.image.src = dataURL;
            document.getElementById('preview').src = $scope.image.src;

            for (var i = 0; i <= e.target.files.length - 1; i++) {
              var fsize = e.target.files.item(i).size;
              var file = Math.round(fsize / 1000);

              if (file > 1000) {
								 $scope.Modal = uibModal.open({
									scope: $scope,
									animationEnabled: true,
									backdrop: 'static',
									templateUrl: '/views/modal/errorModal/errorModal.html',
									controller: 'personalizationController',
									backdrop: 'static',
									size: 'small',
								});
              }
            }

            $scope.$apply();
          };
          if (e.target.files[0]) {
            reader.readAsDataURL($scope.company.logo);
          }
          $scope.company.id = $scope.$parent.$parent.company.Id;
        }
      }

      function save() {
        var splitterArray = 'base64,';
        var ext = $scope.image.src.split(splitterArray);

        var myImg = document.querySelector('#preview');
        $scope.realWidth = myImg.naturalWidth;
        $scope.realHeight = myImg.naturalHeight;
				$scope.messageCancel = $filter('translate')('OK');

        if (ext[0] !== 'data:image/png;') {
					$scope.messageTitle = $filter('translate')('THIS.IS.NOT.A.PNG.IMAGE');
					$scope.messageDescription = $filter('translate')('THE.IMAGE.SHOULD.BE.A.PNG');

					$scope.Modal = uibModal.open({
						scope: $scope,
						animationEnabled: true,
						backdrop: 'static',
						templateUrl: '/views/modal/infoModal/infoModal.html',
						controller: 'personalizationController',
						size: 'small'
					});
          ext[0] = '';
        } else if ($scope.realWidth > 900 || $scope.realHeight > 217) {
					$scope.messageTitle = $filter('translate')('THE.MAXIMUM.RESOLUTION');
					$scope.messageDescription = $filter('translate')('THE.MAXIMUM.RESOLUTION.ALLOWED.IS');

					$scope.Modal = uibModal.open({
						scope: $scope,
						animationEnabled: true,
						backdrop: 'static',
						templateUrl: '/views/modal/infoModal/infoModal.html',
						controller: 'personalizationController',
						size: 'small'
					});
        } else {
					$scope.messageTitle = $filter('translate')('SUCCESS');
					$scope.messageDescription = $filter('translate')('THE.IMAGE.WAS.SAVE');

					$scope.Modal = uibModal.open({
						scope: $scope,
						animationEnabled: true,
						backdrop: 'static',
						templateUrl: '/views/modal/successModal/successModal.html',
						controller: 'personalizationController',
						size: 'small'
					});
        }
      }

			function closeSuccessModal() {
        $scope.Modal.close();
        systemConfigService.saveLogo($scope.company);
      }

      function cancelButton() {
        $scope.Modal.close();
      }

      function questionModal() {
        $scope.image = '';
        $scope.company.logo = '';
        return new Promise(function (resolve) {
          document.getElementById('preview').src = $scope.image.src;
          systemConfigService.saveLogo($scope.company);
          resolve();
          $scope.Modal.close();
        });
      }

      function cancel() {
        if ($scope.image.src) {
          $scope.messageTitle = $filter('translate')('CONFIRM.DELETE.MEDIA');
          $scope.messageCancel = $filter('translate')('NO');
          $scope.messageForward = $filter('translate')('YES');

          $scope.Modal = uibModal.open({
            scope: $scope,
            animationEnabled: true,
            backdrop: 'static',
            templateUrl: '/views/modal/questionModal/questionModal.html',
            controller: 'personalizationController',
            size: 'small',
            windowClass: 'modal-remove',
          });
        }
      }

      function run() {
        try {
          $scope.selectedTab = 'geral';
          $scope.image = '';
          $scope.configuration = null;

          $scope.isSysadmin = logWrapper(
            isSysadmin,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.tabTitle = logWrapper(
            tabTitle,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.getLogoImg = logWrapper(
            getLogoImg,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.addLogo = logWrapper(
            addLogo,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.save = logWrapper(
            save,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.cancelButton = logWrapper(
            cancelButton,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.questionModal = logWrapper(
            questionModal,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.cancel = logWrapper(
            cancel,
            runtimeConstant.isDebugControllersInternals
          );
					 $scope.closeSuccessModal = logWrapper(
            closeSuccessModal,
            runtimeConstant.isDebugControllersInternals
          );
        } catch (error) {
          // eslint-disable-next-line no-console
          console.error(error);
        }
      }

      // Wrap the setup function with logWrapper for debugging purposes
      logWrapper(run, runtimeConstant.isDebugControllers)();
    },
  ],
};
